import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=21fa1959&scoped=true"
import script from "./ImgUpload.vue?vue&type=script&lang=js"
export * from "./ImgUpload.vue?vue&type=script&lang=js"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=21fa1959&prod&lang=less&scoped=true"
import style1 from "./ImgUpload.vue?vue&type=style&index=1&id=21fa1959&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa1959",
  null
  
)

export default component.exports